import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Accept: "application/json",
  },
});

const refreshAxios = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Accept: "application/json",
  },
});

const clearAuthStorage = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("permissions");
  localStorage.removeItem("isLoggedIn");
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest?._retry &&
      !originalRequest?.url?.includes("/login") &&
      !originalRequest?.url?.includes("/refresh")
    ) {
      originalRequest._retry = true;

      try {
        const oldToken = localStorage.getItem("token");
        if (!oldToken) {
          clearAuthStorage();
          window.location.href = "/login";
          return Promise.reject(error);
        }

        const refreshResponse = await refreshAxios.post(
          "/refresh",
          {},
          {
            headers: {
              Authorization: `Bearer ${oldToken}`,
            },
          },
        );

        const newToken = refreshResponse.data.token;

        localStorage.setItem("token", newToken);
        localStorage.setItem("isLoggedIn", "true");

        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        try {
          const meResponse = await refreshAxios.get("/me", {
            headers: {
              Authorization: `Bearer ${newToken}`,
            },
          });
          console.log("meResponse", meResponse);
          const user = meResponse.data.user;
          const permissions = user?.permissions || [];

          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("permissions", JSON.stringify(permissions));
        } catch {
          clearAuthStorage();
          window.location.href = "/login";
          return Promise.reject(error);
        }

        return axiosInstance(originalRequest);
      } catch (refreshError) {
        clearAuthStorage();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

const handleRequest = async (requestFunction) => {
  try {
    const response = await requestFunction();
    return response;
  } catch (error) {
    throw error;
  }
};

export const getApi = async (url, params = {}) => {
  return handleRequest(() => axiosInstance.get(url, { params }));
};

export const getApiById = async (url, id) => {
  return handleRequest(() => axiosInstance.get(`${url}?id=${id}`));
};

export const postApi = async (url, data) => {
  return handleRequest(() =>
    axiosInstance.post(url, data),
  );
};

export const postFormDataApi = async (url, data) => {
  return handleRequest(() =>
    axiosInstance.post(url, data),
  );
};

export const putFormDataApi = async (url, data) => {
  data.append("_method", "PUT");

  return handleRequest(() =>
    axiosInstance.post(url, data),
  );
};

export const deleteApi = async (url, id) => {
  return handleRequest(() => axiosInstance.delete(`${url}?id=${id}`));
};

export default axiosInstance;
